module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Stack</h1>\n</div>\n<iframe src=\"apps/stack/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/stack/component.html
// module id = ../../../../../src/app/pages/stack/component.html
// module chunks = main